import { H4 } from '@hub/heading';
import { Navigation, NavigationButton, NavigationLink, NavigationPanel, NavigationPanelBackButton, NavigationPanelBody, NavigationPanelCloseButton, NavigationPanelHeader, NavigationPanelMenu } from '@hub/navigation';
import React from 'react';
import { AccordionMenu } from './accordion-menu';
import { FindCentreMenu } from './find-centre-menu';
import { Text } from '@hub/text';
import { getAbsolutePathFromRouter } from '../../../helpers/url-helpers';
import { Stack } from '@hub/stack';
import { Button } from '@hub/button';
import { useIsRouteChanging } from '../../../next/router';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useControlledPanel = onClose => {
  const [openedPanel, setOpenedPanel] = React.useState(null);
  const handleClose = React.useCallback(() => {
    setOpenedPanel(null);
    onClose === null || onClose === void 0 || onClose();
  }, [onClose]);
  const toggleOpenedPanel = React.useCallback(name => () => {
    setOpenedPanel(state => name ? state === name ? null : name : null);
  }, []);
  return [openedPanel, toggleOpenedPanel, handleClose];
};
export const HeaderPrimaryMenu = _ref => {
  var _ref2, _ref3, _ref4;
  let {
    centre,
    centres,
    country,
    giftCards,
    isOpen,
    fadeDuration,
    onClose,
    onClickLink,
    onClickButton
  } = _ref;
  const [openedPanel, toggleOpenedPanel, handleClose] = useControlledPanel(onClose);
  const isRouteChanging = useIsRouteChanging();
  const centresMenuItems = React.useMemo(() => centres === null || centres === void 0 ? void 0 : centres.map(centre => ({
    centre,
    label: centre.title,
    url: getAbsolutePathFromRouter({
      route: '[centre]',
      basePath: '/',
      query: {
        centre: centre.slug
      }
    })
  })), [centres]);
  const homeLink = {
    label: 'Explore Westfield',
    url: '/'
  };
  const theEditLink = {
    label: 'The Edit',
    url: '/the-edit'
  };
  const membershipLink = {
    label: 'Membership',
    url: '/membership'
  };
  const customerSupportLink = {
    label: 'Customer Support',
    url: {
      ['Australia']: 'https://support.westfield.com.au',
      ['New Zealand']: 'https://support.westfield.co.nz'
    }[country]
  };
  const findCentreMenu = (_ref2 = centresMenuItems && {
    title: 'Find a centre',
    items: centresMenuItems
  }) !== null && _ref2 !== void 0 ? _ref2 : undefined;
  const visitCentreMenu = (_ref3 = (centre === null || centre === void 0 ? void 0 : centre.navigationMenu) && {
    title: "Visit ".concat(centre.title),
    items: [{
      label: 'Home',
      url: getAbsolutePathFromRouter({
        route: '[centre]',
        basePath: '/',
        query: {
          centre: centre.slug
        }
      })
    }].concat(centre.navigationMenu)
  }) !== null && _ref3 !== void 0 ? _ref3 : undefined;
  const giftCardsMenu = (_ref4 = giftCards && {
    title: 'Gift cards',
    items: giftCards
  }) !== null && _ref4 !== void 0 ? _ref4 : undefined;
  const primaryMenu = {
    title: 'Menu',
    items: [homeLink, ...(!centre && findCentreMenu ? [findCentreMenu] : []), ...(centre && visitCentreMenu ? [visitCentreMenu] : []), ...(giftCardsMenu ? [giftCardsMenu] : []), ...(!centre ? [theEditLink] : []), ...(centres && findCentreMenu ? [findCentreMenu] : []), membershipLink, customerSupportLink]
  };
  const handleClickButton = item => (event, context) => {
    onClickButton === null || onClickButton === void 0 || onClickButton(event, context.isOpen ? 'close' : 'open', [primaryMenu, item]);
  };
  return /*#__PURE__*/_jsx(Navigation, {
    placement: "left",
    trigger: "click",
    backgroundColor: "surfaceBrandPrimary",
    fadeDuration: fadeDuration,
    allowOpen: !isRouteChanging,
    onClose: handleClose,
    "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_Navigation",
    children: /*#__PURE__*/_jsxs(NavigationPanel, {
      isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : false,
      "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_Navigation_NavigationPanel",
      children: [/*#__PURE__*/_jsx(NavigationPanelHeader, {
        "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelHeader",
        children: /*#__PURE__*/_jsx(NavigationPanelCloseButton, {
          "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelHeader_NavigationPanelCloseButton"
        })
      }), /*#__PURE__*/_jsxs(NavigationPanelBody, {
        "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelBody",
        children: [/*#__PURE__*/_jsx(NavigationLink, {
          size: "2xl",
          href: homeLink.url,
          onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [primaryMenu, homeLink]),
          "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelBody_NavigationLink",
          children: homeLink.label
        }), !centre && findCentreMenu && /*#__PURE__*/_jsxs(NavigationPanelMenu, {
          "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu",
          children: [/*#__PURE__*/_jsx(NavigationButton, {
            size: "2xl",
            onClick: handleClickButton(findCentreMenu),
            "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu_NavigationButton",
            children: findCentreMenu.title
          }), /*#__PURE__*/_jsxs(NavigationPanel, {
            "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu_NavigationPanel",
            children: [/*#__PURE__*/_jsxs(NavigationPanelHeader, {
              "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelHeader",
              children: [/*#__PURE__*/_jsx(NavigationPanelCloseButton, {
                isMobileOnly: true,
                onClick: handleClickButton(findCentreMenu),
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelHeader_NavigationPanelCloseButton"
              }), /*#__PURE__*/_jsx(NavigationPanelBackButton, {
                isMobileOnly: true,
                onClick: handleClickButton(findCentreMenu),
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelHeader_NavigationPanelBackButton"
              })]
            }), /*#__PURE__*/_jsx(NavigationPanelBody, {
              "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelBody",
              children: /*#__PURE__*/_jsx(FindCentreMenu, {
                country: country,
                items: findCentreMenu.items,
                onClickLink: (event, path) => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [primaryMenu, findCentreMenu, ...path]),
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelBody_FindCentreMenu"
              })
            })]
          })]
        }), centre && visitCentreMenu && /*#__PURE__*/_jsxs(NavigationPanelMenu, {
          "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu",
          children: [/*#__PURE__*/_jsx(NavigationButton, {
            size: "2xl",
            onClick: (event, context) => {
              handleClickButton(visitCentreMenu)(event, context);
              toggleOpenedPanel('visit-centre')(event);
            },
            active: openedPanel === 'visit-centre',
            "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu_NavigationButton",
            children: visitCentreMenu.title
          }), /*#__PURE__*/_jsxs(NavigationPanel, {
            isOpen: openedPanel === 'visit-centre',
            "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu_NavigationPanel",
            children: [/*#__PURE__*/_jsxs(NavigationPanelHeader, {
              "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelHeader",
              children: [/*#__PURE__*/_jsx(NavigationPanelCloseButton, {
                isMobileOnly: true,
                onClick: handleClickButton(visitCentreMenu),
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelHeader_NavigationPanelCloseButton"
              }), /*#__PURE__*/_jsx(NavigationPanelBackButton, {
                isMobileOnly: true,
                onClick: (event, context) => {
                  toggleOpenedPanel('visit-centre')(event);
                  handleClickButton(visitCentreMenu)(event, context);
                },
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelHeader_NavigationPanelBackButton"
              })]
            }), /*#__PURE__*/_jsxs(NavigationPanelBody, {
              layout: "accordion",
              "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelBody",
              children: [/*#__PURE__*/_jsxs(Stack, {
                direction: "row",
                align: "center",
                gap: "spacing-md",
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelBody_Stack",
                children: [/*#__PURE__*/_jsx(H4, {
                  as: Text,
                  "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_Stack_H4",
                  children: centre.title
                }), /*#__PURE__*/_jsx(Button, {
                  colorScheme: "licorice",
                  variant: "plainText",
                  onClick: toggleOpenedPanel('find-a-centre'),
                  "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_Stack_Button",
                  children: "Change"
                })]
              }), /*#__PURE__*/_jsx(AccordionMenu, {
                items: visitCentreMenu.items,
                onClickLink: (event, path) => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [primaryMenu, visitCentreMenu, ...path]),
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelBody_AccordionMenu"
              })]
            })]
          })]
        }), giftCardsMenu && /*#__PURE__*/_jsxs(NavigationPanelMenu, {
          "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu",
          children: [/*#__PURE__*/_jsx(NavigationButton, {
            size: "2xl",
            onClick: (event, context) => {
              toggleOpenedPanel()(event);
              handleClickButton(giftCardsMenu)(event, context);
            },
            "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu_NavigationButton",
            children: giftCardsMenu.title
          }), /*#__PURE__*/_jsxs(NavigationPanel, {
            "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu_NavigationPanel",
            children: [/*#__PURE__*/_jsxs(NavigationPanelHeader, {
              "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelHeader",
              children: [/*#__PURE__*/_jsx(NavigationPanelCloseButton, {
                isMobileOnly: true,
                onClick: (event, context) => {
                  toggleOpenedPanel()(event);
                  handleClickButton(giftCardsMenu)(event, context);
                },
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelHeader_NavigationPanelCloseButton"
              }), /*#__PURE__*/_jsx(NavigationPanelBackButton, {
                isMobileOnly: true,
                onClick: (event, context) => {
                  toggleOpenedPanel()(event);
                  handleClickButton(giftCardsMenu)(event, context);
                },
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelHeader_NavigationPanelBackButton"
              })]
            }), /*#__PURE__*/_jsxs(NavigationPanelBody, {
              layout: "accordion",
              "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelBody",
              children: [/*#__PURE__*/_jsx(H4, {
                as: Text,
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelBody_H4",
                children: "Gift cards"
              }), /*#__PURE__*/_jsx(AccordionMenu, {
                items: giftCardsMenu.items,
                onClickButton: (event, context, path) => {
                  onClickButton === null || onClickButton === void 0 || onClickButton(event, context.isOpen ? 'close' : 'open', [primaryMenu, giftCardsMenu, ...path]);
                },
                onClickLink: (event, path) => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [primaryMenu, giftCardsMenu, ...path]),
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelBody_AccordionMenu"
              })]
            })]
          })]
        }), !centre && /*#__PURE__*/_jsx(NavigationLink, {
          size: "2xl",
          href: theEditLink.url,
          onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [primaryMenu, theEditLink]),
          "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationLink",
          children: theEditLink.label
        }), centre && findCentreMenu && /*#__PURE__*/_jsxs(NavigationPanelMenu, {
          "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu",
          children: [/*#__PURE__*/_jsx(NavigationButton, {
            size: "md",
            onClick: (event, context) => {
              toggleOpenedPanel('find-a-centre')(event);
              handleClickButton(findCentreMenu)(event, context);
            },
            active: openedPanel === 'find-a-centre',
            "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu_NavigationButton",
            children: findCentreMenu.title
          }), /*#__PURE__*/_jsxs(NavigationPanel, {
            isOpen: openedPanel === 'find-a-centre',
            "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelMenu_NavigationPanel",
            children: [/*#__PURE__*/_jsxs(NavigationPanelHeader, {
              "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelHeader",
              children: [/*#__PURE__*/_jsx(NavigationPanelCloseButton, {
                isMobileOnly: true,
                onClick: handleClickButton(findCentreMenu),
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelHeader_NavigationPanelCloseButton"
              }), /*#__PURE__*/_jsx(NavigationPanelBackButton, {
                isMobileOnly: true,
                onClick: (event, context) => {
                  toggleOpenedPanel('find-a-centre')(event);
                  handleClickButton(findCentreMenu)(event, context);
                },
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelHeader_NavigationPanelBackButton"
              })]
            }), /*#__PURE__*/_jsx(NavigationPanelBody, {
              "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanel_NavigationPanelBody",
              children: /*#__PURE__*/_jsx(FindCentreMenu, {
                country: country,
                items: findCentreMenu.items,
                onClickLink: (event, path) => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [primaryMenu, findCentreMenu, ...path]),
                "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelBody_FindCentreMenu"
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(NavigationLink, {
          size: "md",
          href: membershipLink.url,
          openInNewWindow: true,
          onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [primaryMenu, membershipLink]),
          "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelBody_NavigationLink",
          children: membershipLink.label
        }), /*#__PURE__*/_jsx(NavigationLink, {
          size: "md",
          href: customerSupportLink.url,
          onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [primaryMenu, customerSupportLink]),
          "data-id": "header-menus_primary-menu_HeaderPrimaryMenu_NavigationPanelBody_NavigationLink_44",
          children: customerSupportLink.label
        })]
      })]
    })
  });
};